import 'rc-slider/assets/index.css';
import * as apiValues from '../constants/apiValues';
import { MAP_IFRAME_TITLE } from '../constants/mapAccessibility';
import * as helpers from '../helpers';
import * as mapProgramActions from '../actions/mapProgramActions';
import iconArrowRight from '../img/icon-arrow-right-black.png';
import iconClose from '../img/icons/icon-close.svg';
import loadingIcon from '../img/loading-icon-small.gif';
import ProgramBanner from './ProgramBanner';
import PropTypes from 'prop-types';
import React from 'react';
import ShareMemorial from './ShareMemorial';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Range } from 'rc-slider';
import { withRouter } from '../withRouterCompat';
import moment from 'moment';
import MarkdownField from './MarkdownField';
import { isMemorialMapSelectedFeature } from '../utils/mapSelectedFeature';
import {
  getOverallMapProjectDrawPlan,
  getOverallMapProjectPrograms,
} from '../utils/overallMapPrograms';
import {resolveInitialOverallMapTab} from '../utils/mapsAndDataNav';
import {
  buildProjectFeatureLayerState,
  featureTypesResponseKind,
  formatOverallProjectFeatureLabel,
  mergeProjectFeatureTypes,
} from '../utils/projectFeatureMapTypes';


// Must match map iframe origin (includes port when app is not on :80/:443)
const currentDomain = window.location.origin;

// let initMapPayload = {
//   testMsg: "Hello World!!!",
//   debug: true,
//   isCMS: false,  // flag for CMS or Public version
//   ui_ZoomLevel: "lab-zoom",  // defines HTML element showing current zoomlevel
//   map_html_class: "map-render-area", // this would be the "class" name of the div for example <div class="map-render-area"></div> whether in the CMS or in the PUB site
//   map_div_id: "map-primary-render-area", // since you can only have one "id" on a html page, you would only be able to use this once. Examples: <div id="map-primary"></div>, <div class="map-render-area"></div>, <div id="somethingelse" class="map-render-area"></div>
//   memorial_csv: "./test_memorial.csv"
// };

//TODO you may not need the project_id, pif if passed directly however if you do
//you can use this to temporarily store data for reference locally.
let dcrMappingData = {
  project_id: '',
  pif: '',
  params: [],
  functionName: '',
  selectedEditLayer: '',
  currentProgram: 'all',
  currentProgramStatus: 'all',
  startDate: '2017',
  endDate: '2018',
};
let layer_names = {};
let features_types_name = [];
let default_layers = [];
const overallProgram = {
  title: 'Overall Map & Data',
  color: '#3D5741',
  mapsIntroText: '',
};

const OVERALL_PROJECT_FEATURE_LAYERS = ['cms_feature_points', 'cms_feature_lines'];
/** Legacy preset layers that are not CMS project features (pre-LLSU2-151). */
const LEGACY_STREET_IMPROVEMENT_LAYERS = ['greatst', 'pst_parklet', 'pst_plaza', 'bikeway', 'srts_top50'];

/** Display names for overall-map tab layers (iframe getMapLayer also updates layer_names). */
const OVERALL_LAYER_LABELS = {
  vz_hiinjnet: 'High-Injury Network',
  mobplan2035_ten: 'Mobility Plan 2035: Transit Enhanced Network',
  mobplan2035_bpn: 'Mobility Plan 2035: Bicycle Path Network',
  mobplan2035_bln: 'Mobility Plan 2035: Bicycle Network',
  mobplan2035_nen: 'Mobility Plan 2035: Neighborhood Enhanced Network',
  mobplan2035_peds: 'Mobility Plan 2035: Pedestrian Enhanced Districts',
  council_dist: 'Council Districts',
  nbhood_council_dist: 'Neighborhood Council Districts',
  memorial: 'Memorials',
  coll_ped_fatal: 'Walking',
  coll_bik_fatal: 'Biking',
  coll_car_fatal: 'Driving',
  greatst: 'Great Streets Initiative',
  pst_parklet: 'Projects - Parklets',
  pst_plaza: 'Projects - Plazas',
  bikeway: 'Bikeways',
  srts_top50: 'Top 50 Schools',
};

function seedOverallLayerNames(){
  Object.entries(OVERALL_LAYER_LABELS).forEach(([id, name]) => {
    layer_names[id] = name;
  });
}

function buildLayersStateFromTabs(tabs, programs){
  const layers = {};
  if(!tabs) return layers;

  tabs.forEach(({id, layers: tabLayers}) => {
    if(id === 'overall-projects'){
      const layer_data = {};
      getOverallMapProjectPrograms(programs).forEach(item => {
        layer_data[item.slug] = true;
        layer_names[item.slug] = item.title;
      });
      layers[id] = layer_data;
      return;
    }

    const layer_data = {};
    (tabLayers || []).forEach(layer => {
      layer_data[layer] = id === 'overall-neighborhoods_zones' && layer === 'vz_hiinjnet';
    });
    if(Object.keys(layer_data).length > 0){
      layers[id] = layer_data;
    }
  });

  return layers;
}


class OverallMap extends React.Component{
  constructor(props){
    super(props);

    let slug = props.location.search;
    let memorialPopUpName = null;
    if(slug && slug.includes('sharememorial')){
      slug = slug.split('-');
      memorialPopUpName = slug[1].replace('%20', ' ');
      slug = slug[0].replace('sharememorial=', '').replace('?', '');
    }
    else{
      slug = null;
    }

    seedOverallLayerNames();

    this.state = {
      showMemorial: slug,
      memorialPopUpName,
      collisions: 0,
      collisionDetail: {},
      feedbackAddress: '',
      currentLayers: [],
      currentTab: resolveInitialOverallMapTab(props.location && props.location.search, props.tabs),
      height: window.innerHeight,
      width: window.innerWidth,
      selectedObject: null,
      memorialDateFilter: [2017, 2018],
      mapPluginReady: false,
      tabContentClose: false,
      panelShouldSlide: false,
      layers: buildLayersStateFromTabs(props.tabs, props.page && props.page.program),
    };

    //this.componentDidMount = this.componentDidMount.bind(this);
    this.bindEvents = this.bindEvents.bind(this);
    this.sendMessageToChild = this.sendMessageToChild.bind(this);
    this.sendDirectlyToChild = this.sendDirectlyToChild.bind(this);
    this.recieveMessageFromChild = this.recieveMessageFromChild.bind(this);
    this.testBtn = this.testBtn.bind(this);
    this.zoomToOpt = this.zoomToOpt.bind(this);
    this.getMapLayersBtn = this.getMapLayersBtn.bind(this);
    this.mapmodeOpt = this.mapmodeOpt.bind(this);
    this.programOpt = this.programOpt.bind(this);
    this.projectOpt = this.projectOpt.bind(this);
    this.drawLayer = this.drawLayer.bind(this);
    this.setDateStart = this.setDateStart.bind(this);
    this.setDateEnd = this.setDateEnd.bind(this);
    this.statusOpt = this.statusOpt.bind(this);
    this.startEditingOpt = this.startEditingOpt.bind(this);
    this.stopEditingBtn = this.stopEditingBtn.bind(this);
    this.handleMessageFromChild = this.handleMessageFromChild.bind(this);
    this.updateFeatureCount = this.updateFeatureCount.bind(this);
    this.enableFeedbackBtn = this.enableFeedbackBtn.bind(this);
    this.displayFeedbackAddressPoint = this.displayFeedbackAddressPoint.bind(
      this,
    );
    this.updateDimensions = this.updateDimensions.bind(this);
    this._featureTypeResponses = {point: null, line: null};
    this.applyMergedProjectFeatureTypes = this.applyMergedProjectFeatureTypes.bind(this);
    this.requestProjectFeatureTypes = this.requestProjectFeatureTypes.bind(this);
  }
  componentDidMount(){
    this.props.actions.fetchMemorials();
    this.bindEvents();
    window.addEventListener('resize', this.updateDimensions);
    this._mapReadyFallback = window.setTimeout(() => {
      this.setState(prev => (prev.mapPluginReady ? null : {mapPluginReady: true}));
    }, 8000);
  }
  mergeProgramLayers(programs){
    const layer_data = {};
    getOverallMapProjectPrograms(programs).forEach(item => {
      layer_data[item.slug] = true;
      layer_names[item.slug] = item.title;
    });
    if(Object.keys(layer_data).length === 0) return;

    this.setState(prev => {
      const existing = prev.layers && prev.layers['overall-projects'];
      const keys = Object.keys(layer_data);
      if(
        existing &&
        keys.length === Object.keys(existing).length &&
        keys.every(key => Object.prototype.hasOwnProperty.call(existing, key))
      ){
        return null;
      }
      return {
        layers: {
          ...prev.layers,
          'overall-projects': layer_data,
        },
      };
    });
  }
  drawCheckedOverallMapProjects(programs, layerChecks){
    const plan = getOverallMapProjectDrawPlan(
      programs,
      layerChecks || (this.state.layers && this.state.layers['overall-projects']),
    );
    if(plan.drawAll){
      this.sendMessageToChild({
        functionName: 'drawProjectsById',
        params: [[]],
      });
      return;
    }
    if(plan.ids.length === 0){
      this.sendMessageToChild({
        functionName: 'drawLayer',
        params: ['cms_project_polygons', false],
      });
      return;
    }
    this.sendMessageToChild({
      functionName: 'drawProjectsById',
      params: [plan.ids],
    });
  }
  hideCmsProjectPolygons(){
    this.sendMessageToChild({
      functionName: 'drawLayer',
      params: ['cms_project_polygons', false],
    });
  }
  hideOverallProjectFeatureLayers(){
    OVERALL_PROJECT_FEATURE_LAYERS.forEach(layerId => {
      this.sendMessageToChild({
        functionName: 'drawLayer',
        params: [layerId, false],
      });
    });
  }
  applyOverallMapTabOverlays(tabName){
    if(tabName === 'overall-projects'){
      this.hideOverallProjectFeatureLayers();
      const programs = this.props.page && this.props.page.program;
      if(programs && programs.length > 0){
        this.drawCheckedOverallMapProjects(programs);
      }
      return;
    }

    this.hideCmsProjectPolygons();
    if(tabName !== 'overall-project_features'){
      this.hideOverallProjectFeatureLayers();
    }
  }
  componentWillUnmount(){
    window.removeEventListener('resize', this.updateDimensions);
    if(this._mapReadyFallback){
      window.clearTimeout(this._mapReadyFallback);
    }
  }


  filteringApply_onClick = () => {
    this.setState({filtersOpen: false});
  };
  filteringCancel_onClick = () => {
    this.setState({
      filtersOpen: false,
      currentLayers: this.state.previousLayers,
    });
  };
  filteringOpen_onClick = () => {
    let newState = {filtersOpen: !this.state.filtersOpen};
    if(!this.state.filtersOpen)
      newState.previousLayers = this.state.currentLayers;
    this.setState(newState);
  };
  mapClose_onClick = () => {
    this.setState({mapOpen: false});
  };
  mapOpen_onClick = () => {
    this.setState({mapOpen: !this.state.mapOpen});
  };


  /**
   * This function binds events from this javascript file to the browser
   */
  bindEvents(){
    // Assign handler to message event from the browser window.
    if(window.addEventListener){
      window.addEventListener('message', this.recieveMessageFromChild, false);
    }
    else if(window.attachEvent){
      // supports ie8
      window.attachEvent('onmessage', this.recieveMessageFromChild);
    }
  }
  changeValue = value => {
    this.setState({
      memorialDateFilter: value,
    });
    this.sendMessageToChild({
      functionName: 'setDateFilter',
      params: ['collisions', value[0], value[1]],
    });
  };
  displayFeedbackAddressPoint(data){
    //console.group("parent.html > parent.js > displayFeedbackAddressPoint");
    //console.log("data:", data);
    //console.log("MapProgram before setState this.state", this.state);
    this.setState({feedbackAddress: data.address});
    //console.log("MapProgram after setState this.state", this.state);
    //console.groupEnd();
  }
  getMapLayersBtn(){
    this.sendMessageToChild({
      functionName: 'getMapLayer',
      params: ['srts_top50'],
    });
  }
  drawLayer(event){
    //console.log("MapProgram -> drawLayer event: ", event);
    //console.log("MapProgram -> drawLayer event.target.value: ", event.target.value);
    //console.log("MapProgram -> drawLayer event.target.name: ", event.target.name);
    //console.log("MapProgram -> drawLayer event.target.getAttribute(map-layer): ", event.target.getAttribute("map-layer"));

    this.sendMessageToChild({
      functionName: event.target.getAttribute('service-task'),
      params: [event.target.getAttribute('map-layer'), event.target.value],
    });
  }
  enableFeedbackBtn(event){
    //console.log("MapProgram -> enableFeedbackBtn event: ", event);
    //TODO event.target.getAttribute('service-task')
    this.sendMessageToChild({
      functionName: event.target.getAttribute('service-task'),
      params: [], // project_id is optional to test if point inside projecta area
    });
  }
  handleGoToProjectDetail = data => {
    // const program = this.props.page.program.find(item => item.slug === layer_id);
    let selectedProject;
    this.props.page.program.forEach(program => {
      program.project.forEach(project => {
        // console.log(`project id = ${project.projectId} == ? ${project.projectId == data.project_id}`);
        if(project.projectId == data.project_id) selectedProject = project;
      });
    });
    if(selectedProject) this.props.history.push(`/projects/${selectedProject.slug || ''}`);
    else console.error(`couldn't find project with id ${data.project_id}`);
  };
  handleMessageFromChild(data){
    // console.log(`handleMessageFromChild(data)`, data);
    // DCR_Mapping test response
    // =============================

    //console.group("parent.html > parent.js > handleMessageFromChild");
    //console.log('data:', data);
    //console.log(typeof data);
    // console.log("--handlemsssage---", data);
    if(data && data.functionName){
      let memorialMapTab = this.props.tabs.find(tab => tab.id.indexOf('memorial_map') >= 0);
      switch(data.functionName){
        case 'mapPluginReady':
          this.mapLoaded();
          break;
        case 'mapConfigError':
          this.setState({
            mapConfigError: data.message || 'Map configuration failed to load.',
            mapPluginReady: false,
          });
          break;
        case 'projectPopupClicked':
          this.handleGoToProjectDetail(data);
          break;
        case 'updateFeatureCount':
          this.updateFeatureCount(data);

          break;

        case 'displayFeedbackAddressPoint':
          this.displayFeedbackAddressPoint(data);

          break;
        case 'getMapLayerGroup':{
          const {mode} = this.props;
          const layers = data.layers.layers;
          const group_id = data.layers.id;
          let layer_data = {};
          layers.forEach(layer => {
            this.sendMessageToChild({
              functionName: 'getMapLayer',
              params: [layer], // no arg
            });
            if(group_id == `${mode}-default`){
              default_layers.push(layer);
            }
            layer_data[layer] = default_layers.includes(layer);
            // if (layer === 'coll_ped_fatal') {
            //   layer_data[layer] = false;
            // }
          });
          this.setState({
            ...this.state,
            layers: {
              ...this.state.layers,
              [group_id]: layer_data,
            },
          });
        }
          break;
        case 'getFeatureTypes':{
          if(data.types.length === 0){
            setTimeout(() => {
              this.requestProjectFeatureTypes();
            }, 3000);
          }
          else{
            const kind = featureTypesResponseKind(data.types);
            this._featureTypeResponses[kind] = data.types;
            this.applyMergedProjectFeatureTypes();
          }
        }
          break;
        case 'getMapLayer':{
          const layer = data.layer;
          if(layer && layer.id && layer.name && layer_names[layer.id] !== layer.name){
            layer_names[layer.id] = layer.name;
            this.setState(prev => ({
              layerNameRevision: (prev.layerNameRevision || 0) + 1,
            }));
          }
        }
          break;
        case 'selectedFeature':
          if(memorialMapTab && isMemorialMapSelectedFeature(data)){
            this.selectTab(memorialMapTab.id);
            setTimeout(() => {
              this.setState({
                selectedObject: data.values.caseid,
                memorialPopUpName: data.values.name,
              });
            });
          }
          break;
        case 'memorialPopupMore':
          console.log('----memorialPopupMore', data);
          break;
        case 'cmsFeaturePopupMore':
          console.log('----cmsFeaturePopupMore', data);
          break;

        case 'collisionPopupClicked':
          window.location = `mailto:visionzero@lacity.org?subject=Vision Zero Memorial Unidentified person (ID: ${data.case_id})&body=Hello, I am visiting the Vision Zero Memorial of someone I know and would like to create a memorial for them.`;
          break;

        default:
        //console.warn("Error with payload data", data);
      }
    }
    //console.groupEnd();
  }
  handleMemorialContent = () => {
    this.setState({
      selectedObject: null,
      showMemorial: null,
    });
  };
  handleTabContentClose = () => {
    // this.setState({
    //   tabContentClose: true,
    // });
    this.selectTab('');
  };
  mapLoaded(){
    if(this._mapLoadedDone) return;
    this._mapLoadedDone = true;

    this.sendMessageToChild({
      functionName: 'setMapMode',
      params: ['safe_routes_for_seniors'],
    });

    const layersFromTabs = buildLayersStateFromTabs(
      this.props.tabs,
      this.props.page && this.props.page.program,
    );

    this.props.tabs.forEach(({layers: tabLayers}) => {
      (tabLayers || []).forEach(layer => {
        this.sendMessageToChild({
          functionName: 'getMapLayer',
          params: [layer],
        });
      });
    });

    this.setState(prev => ({
      layers: {
        ...prev.layers,
        ...layersFromTabs,
      },
      mapPluginReady: true,
    }));

    if(this.props.page && this.props.page.program && this.props.page.program.length > 0){
      this.mergeProgramLayers(this.props.page.program);
    }

    this.applyOverallMapTabOverlays(this.state.currentTab);

    if(this.state.currentTab === 'overall-project_features'){
      this.showOverallProjectFeatures();
    }

    this.sendMessageToChild({
      functionName: 'zoomToLoc',
      params: ['city_la'],
    });
    this.sendMessageToChild({
      functionName: 'setDateFilter',
      params: ['collisions', this.state.memorialDateFilter[0], this.state.memorialDateFilter[1]],
    });
    this.requestProjectFeatureTypes();
  }
  requestProjectFeatureTypes(){
    this._featureTypeResponses = {point: null, line: null};
    this.sendMessageToChild({
      functionName: 'getFeatureTypes',
      params: ['point'],
    });
    this.sendMessageToChild({
      functionName: 'getFeatureTypes',
      params: ['line'],
    });
  }
  applyMergedProjectFeatureTypes(){
    const {point, line} = this._featureTypeResponses;
    if(!point || !line){
      return;
    }

    features_types_name = mergeProjectFeatureTypes(point, line);
    const layer_data = buildProjectFeatureLayerState(features_types_name);
    this.setState({
      layers: {
        ...this.state.layers,
        'overall-project_features': layer_data,
      },
    });
  }
  showOverallProjectFeatures(){
    this.sendMessageToChild({
      functionName: 'drawLayerGroup',
      params: ['overall-project_features'],
    });
    LEGACY_STREET_IMPROVEMENT_LAYERS.forEach(layerId => {
      this.sendMessageToChild({
        functionName: 'drawLayer',
        params: [layerId, false],
      });
    });
    OVERALL_PROJECT_FEATURE_LAYERS.forEach(layerId => {
      this.sendMessageToChild({
        functionName: 'drawLayer',
        params: [layerId, true],
      });
      this.sendMessageToChild({
        functionName: 'drawLayerFeature',
        params: [layerId, 'reset'],
      });
    });
  }
  mapmodeOpt(event){
    //console.log("MapProgram -> mapmodeOpt event: ", event);
    //console.log("MapProgram -> mapmodeOpt event.target.value: ", event.target.value);

    this.sendMessageToChild({
      functionName: event.target.getAttribute('service-task'),
      params: [event.target.value],
    });
  }
  onToggleLayer(layer_id){
    const toggle = !this.state.layers[this.state.currentTab][layer_id];
    this.setState({
      ...this.state,
      layers: {
        ...this.state.layers,
        [this.state.currentTab]: {
          ...this.state.layers[this.state.currentTab],
          [layer_id]: toggle,
        },
      },
    });

    if(this.state.currentTab === 'overall-projects'){
      const nextChecks = {
        ...this.state.layers['overall-projects'],
        [layer_id]: toggle,
      };
      this.drawCheckedOverallMapProjects(this.props.page.program, nextChecks);
    }
    else{
      this.sendMessageToChild({
        functionName: 'drawLayer',
        params: [layer_id, toggle],
      });
    }
  }
  onToggleFeatureLayer(layer_id){
    const toggle = !this.state.layers[this.state.currentTab][layer_id];
    this.setState({
      ...this.state,
      layers: {
        ...this.state.layers,
        [this.state.currentTab]: {
          ...this.state.layers[this.state.currentTab],
          [layer_id]: toggle,
        },
      },
    });
    this.sendMessageToChild({
      functionName: 'drawLayerFeature',
      params: ['cms_feature_points', layer_id, toggle],
    });
    this.sendMessageToChild({
      functionName: 'drawLayerFeature',
      params: ['cms_feature_lines', layer_id, toggle],
    });
  }
  programOpt(event){
    //console.log("MapProgram -> programOpt event: ", event);
    //console.log("MapProgram -> programOpt event.target.value: ", event.target.value);

    dcrMappingData.currentProgram = event.target.value;

    //console.log("MapProgram -> programOpt dcrMappingData.currentProgram: ", dcrMappingData.currentProgram);

    this.sendMessageToChild({
      functionName: 'drawProjects',
      params: [
        dcrMappingData.currentProgram,
        dcrMappingData.currentProgramStatus,
      ],
    });
  }
  projectOpt(event){
    this.sendMessageToChild({
      functionName: 'zoomToProject',
      params: [event.target.value],
    });

    // this.sendMessageToChild({
    //   functionName: "drawFeaturesByProject",
    //   params: [event.target.value]
    // });

    this.sendMessageToChild({
      functionName: 'drawFeaturesByProject',
      params: [event.target.value, 'vision_zero'],
    });
  }
  /**
   * This function listens for an event from the browser message event and returns a JSON
   * @param {*} event
   */
  recieveMessageFromChild(event){
    // console.log(`recieveMessageFromChild(event)`, event);
    //console.group("MapProgram parent.html > parent.js > recieveMessageFromChild");
    //console.log(event);
    if(event.origin === currentDomain){
      //WARNING this is used to verify the source of the message, aka whitelist
      // Retrieve data sent in postMessage

      //console.log("MapProgram event.origin", event.origin);
      //console.log("MapProgram currentDomain", currentDomain);
      //console.log("MapProgram event.data", event.data);

      if(event.data){
        // console.log("Message received from child:", JSON.parse(event.data));
        //console.groupEnd();

        let data = typeof event.data == 'object' ? event.data : JSON.parse(event.data);
        this.handleMessageFromChild(data);

        return data;
      }
      else{
        //console.warn("Check message payload on event.data", event.data);
      }
    }
    else{
      //console.warn("Error with validating origin: " + event.origin + " !== " + currentDomain);
    }
  }
  getTabPanelContainerProps(tabId){
    const slideIn = this.state.panelShouldSlide;
    return {
      className: `map-program__tab-content-container${slideIn ? ' map-program__tab-content-container--slide-in' : ''}`,
      id: `map-tab-panel-${tabId}`,
      role: 'tabpanel',
      'aria-labelledby': `map-tab-${tabId}`,
      onAnimationEnd: slideIn ? this.onTabPanelSlideEnd : undefined,
    };
  }
  onTabPanelSlideEnd = (event) => {
    if(event.target !== event.currentTarget || event.animationName !== 'slideInFromLeft'){
      return;
    }
    if(this.state.panelShouldSlide){
      this.setState({panelShouldSlide: false});
    }
  };
  selectTab(tabName){
    const wasClosed = !this.state.currentTab;
    switch(tabName){
      case 'overall-project_features':{
        this.showOverallProjectFeatures();
      }
        break;
      case 'overall-memorial_map':{
        this.sendMessageToChild({
          functionName: 'setDateFilter',
          params: ['collisions', this.state.memorialDateFilter[0], this.state.memorialDateFilter[1]],
        });
      }
        break;
    }
    this.applyOverallMapTabOverlays(tabName);
    this.setState({
      ...this.state,
      currentTab: tabName,
      showMemorial: null,
      tabContentClose: false,
      panelShouldSlide: wasClosed && tabName !== '',
    });
  }
  /**
   * // TODO: Talk to Roland about strictly defining the params as a JSON Object,
   * that way you can just use this function and pass parameters directly,
   * with a strictly defined JSON Object he would have easier time validating the parameters too
   *
   * Currently this will not work unless his parameters are properly defined.
   *
   * @param {*} event
   */
  sendDirectlyToChild(event){
    //console.group("parent.html > parent.js > sendDirectlyToChild");
    //console.log(event);

    this.sendMessageToChild({
      functionName: event.target.getAttribute('service-task'),
      params: [],
    });
    //console.groupEnd();
  }
  /**
   * This function sents a message from the parent to the child.
   *
   * It can be called by passing a JSON as an example
   *
   * sentMessageToChild({ //payload is being defined at the moment w/ DCR Maps Team.
        mapMode: programs-projects, // can also be program-projects, project-details, feedback, memorial
        program: [vision_zero, active_transporation, ...]
        projects: [data_collection_feedback, plannding_design, construction, ...] , // can also be data_collection_feedback, planning_design, construction, completed, post_project_evaluation, active
        ui_ZoomLevel: "lab-zoom", // defines HTML element showing current zoomlevel,
   * })
   *
   */
  sendMessageToChild(payload){
    //console.group("parent.html > parent.js > sendMessageToChild");
    //console.log(payload);
    if(payload){
      this.iframe.contentWindow.postMessage(
        JSON.stringify(payload),
        currentDomain,
      );
    }

    //console.log("MapProgram -> dcrMappingData: ", dcrMappingData);
    //console.groupEnd();
  }
  setDateEnd(event){
    dcrMappingData.endDate = event.target.value;

    this.sendMessageToChild({
      functionName: event.target.getAttribute('service-task'),
      params: ['collisions', dcrMappingData.startDate, dcrMappingData.endDate],
    });
  }
  setDateStart(event){
    dcrMappingData.startDate = event.target.value;

    this.sendMessageToChild({
      functionName: event.target.getAttribute('service-task'),
      params: ['collisions', dcrMappingData.startDate, dcrMappingData.endDate],
    });
  }
  startEditingOpt(event){
    //console.log("MapProgram -> startEditingOpt event: ", event);
    //console.log("MapProgram -> startEditingOpt event.target.value: ", event.target.value);

    //store selectedLayer for referenceing stopEditingBtn();
    dcrMappingData.selectedEditLayer = event.target.value;

    //console.log("MapProgram -> dcrMappingData: ", dcrMappingData);
    this.sendMessageToChild({
      functionName: 'startEditing',
      params: [event.target.value, {project_id: '0', pif: 'Test'}],
    });
  }
  statusOpt(event){
    //store currentProgramStatus
    dcrMappingData.currentProgramStatus = event.target.value;

    // this.sendMessageToChild({
    //   functionName: "drawProjects",
    //   params: [dcrMappingData.currentProgram, dcrMappingData.currentProgramStatus]
    // });
    this.sendMessageToChild({
      functionName: event.target.getAttribute('service-task'),
      params: [
        dcrMappingData.currentProgram,
        dcrMappingData.currentProgramStatus,
      ],
    });
  }
  stopEditingBtn(){
    this.sendMessageToChild({
      functionName: 'stopEditing',
      params: [dcrMappingData.selectedEditLayer],
    });
  }
  testBtn(){
    //console.log("MapProgram -> testBtn this.state", this.state);
    //console.log("MapProgram -> testBtn this.props", this.props);
    //console.log("MapProgram -> testBtn this.actions", this.props.actions);

    this.sendMessageToChild({
      functionName: 'test',
      params: [], // no arg
    });
  }
  updateDimensions(){
    this.setState({
      height: window.innerHeight,
      width: window.innerWidth,
    });
  }
  updateFeatureCount(data){
    //console.group("parent.html > parent.js > updateFeatureCount");
    //console.log("data:", data);

    //console.log("MapProgram before setState this.state", this.state);
    //let dcrmap = {...this.state.dcrmap, collisions : data.count};

    const collisionDetail = this.state.collisionDetail;
    collisionDetail[data.layer] = data.count;

    this.setState({
      collisions: data.count,
      collisionDetail,
    });

    //console.log("MapProgram after setState this.state", this.state);
    //console.log(this.state.collisions);
    //console.groupEnd();
  }
  zoomToOpt(event){
    //console.log("MapProgram -> zoomtoOpt event: ", event);
    //console.log("MapProgram -> zoomtoOpt event.target.value: ", event.target.value);

    //TODO: Since the params array doesn't need to be stored, you can reuse it but it must be cleared first.
    dcrMappingData.params.splice(0, dcrMappingData.params.length); //empties dcrMappingData.params array

    this.sendMessageToChild({
      functionName: event.target.getAttribute('service-task'),
      params: [event.target.value],
    });
  }


  renderFilterControls(){
    if(!this.state.mapOpen) return null;

    return (
      <div className="map-program__tab-menu-buttons col">
        <button className="tg-button tg-button--pill tg-button--black flex-fill"
                onClick={this.filteringApply_onClick}>
          <span className="tg-button__label">Apply</span>
        </button>
        <button className="tg-button tg-button--pill tg-button--white-ghost flex-fill"
                onClick={this.filteringCancel_onClick}>
          <span className="tg-button__label">Cancel</span>
        </button>
      </div>
    );
  }
  renderIntroSection(){
    const buttonDisplayClass = this.state.mapOpen ? 'd-none' : '';
    return (
      <div className="map-program__intro coupling coupling--centered">
        <div className="container container--coupling">
          <div className="map-program__intro-title-container">
            <div>
              <ProgramBanner program={overallProgram}/>
            </div>
            <div className="map-program__intro-title">Maps</div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="map-program__intro-description">
                {overallProgram.mapsIntroText}
              </div>

              <button className={`map-program__view-maps-button tg-button tg-button--pill tg-button--black ${buttonDisplayClass}`}
                      onClick={this.mapOpen_onClick}>
                <span className="tg-button__label">View Maps</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
  renderMapControls = () => {
    if(!this.state.mapOpen) return null;

    return (
      <>
        <button className="map-program__map-button map-program__map-button--filtering"
                onClick={this.filteringOpen_onClick}>
          Open Filtering
        </button>
        <button className="map-program__map-button map-program__map-button--close"
                onClick={this.mapClose_onClick}>
          Close
        </button>
      </>
    );
  };
  renderMapLoadingIconDesktop = () => {
    if(this.state.mapPluginReady) return null;

    return (<img alt="Loading" src={loadingIcon} className="map-loading-icon"/>);
  };
  renderMapLoadingIconMobile = () => {
    if(this.state.mapPluginReady || !this.state.mapOpen) return null;

    return (<img alt="Loading" src={loadingIcon} className="map-loading-icon-mobile"/>);
  };
  renderMapSection(){
    const displayClass = this.state.mapOpen ? 'map-program__map--is-open' : '';
    if(this.state.mapConfigError){
      return (
        <div className={`map-program__map ${displayClass}`}>
          <p className="coupling coupling--centered-thin" role="alert">{this.state.mapConfigError}</p>
        </div>
      );
    }
    return (
      <div className={`map-program__map ${displayClass}`}>
        {this.renderTabs()}
        <div className="map-program__map-iframe-container">
          {this.renderMapLoadingIconDesktop()}
          {this.renderMapLoadingIconMobile()}
          <iframe className="map-program__map-iframe"
                  title={MAP_IFRAME_TITLE}
                  src={`/maps/child.html?cms_path=${apiValues.getCmsPath()}`}
                  ref={event => (this.iframe = event)}/>
        </div>
        {this.renderMapControls()}
      </div>
    );
  }
  renderTab(id, name, icon){
    const isActive = this.state.currentTab === id;
    let className = 'map-program__tab' + (isActive ? ' active' : '');
    return (
      <div key={id} className={`map-program__tab-container${isActive ? ' map-program__tab-container--active' : ''}`}>
        <button type="button"
                className={className}
                role="tab"
                id={`map-tab-${id}`}
                aria-selected={isActive}
                aria-expanded={isActive}
                aria-controls={isActive ? `map-tab-panel-${id}` : undefined}
                onClick={(e) => {
                  e.preventDefault();
                  this.selectTab(id);
                }}
                onFocus={() => {
                  if(this.state.currentTab !== id){
                    this.selectTab(id);
                  }
                }}>
          <img alt="" className="map-program__tab-icon" src={icon}/>
          <span className="map-program__tab-title">{name}</span>
        </button>
        {isActive ? this.renderTabContent(id) : null}
      </div>
    );
  }
  renderTabContent(tabId){
    if(tabId !== this.state.currentTab) return null;
    if(this.state.tabContentClose === true) return null;
    if(this.state.showMemorial){
      const memorial = this.props.mapProgram.memorials.find(
        memorial => (memorial.caseId ? memorial.caseId.toString() : '') === this.state.showMemorial.toString() && memorial.title.toLowerCase() === this.state.memorialPopUpName.toLowerCase(),
      );
      if(memorial){
        //todo: why is this duplicated below??
        return (
          <div {...this.getTabPanelContainerProps(tabId)}
               style={{width: 'calc(100vw - 214px)'}}>
            <button aria-label="Close panel"
                    className="button-input__button tab-content-close-icon"
                    type="button" onClick={this.handleTabContentClose}>
              <img alt="" className="button-input__button-icon" src={iconClose}/>
            </button>
            <div className="map-program__tab-content"
                 key={this.state.currentTab}>
              <button type="button"
                      aria-label="Back to layer list"
                      className="memorial-close-button"
                      onClick={this.handleMemorialContent}>
                <img alt="" className="button__icon" src={iconArrowRight}/>
              </button>
              {memorial.title && (<div className="map-program__memorial-title">{`${memorial.title}, ${memorial.age || ''}`}</div>)}
              {memorial.eventDate && (<div className="map-program__memorial-event">{`Died on ${moment(memorial.eventDate).format('MMMM D, YYYY')}`}</div>)}
              {memorial.address && (<div className="map-program__memorial-address">{memorial.address}</div>)}
              {memorial.media && (<div className="map-program__memorial-content">
                <img alt={memorial.title}
                     className="map-program__memorial-media-imagery"
                     src={apiValues.imgPath(memorial.media.url)}/>
              </div>)}
              {memorial.description && (<MarkdownField className="map-program__memorial-description" markup={memorial.description}/>)}
              <a className='map-program__memorial-know' href={`mailto:visionzero@lacity.org?subject=Vision Zero Memorial Unidentified person (ID: ${this.state.selectedObject.toString()})&body=Hello, I am visiting the Vision Zero Memorial of someone I know and would like to create a memorial for them.`}>Did you know this person?</a>
              {/* <div className="map-program__memorial-read-more">
                READ MORE
                <MListNav
                  mListNav={mListNav}
                  className="m-listnav--page-content"
                />
              </div> */}
              <ShareMemorial shareUrl={document.URL}
                             pageTitle={`${overallProgram.title} Memorial Map - ${memorial.title || ''}`}/>
            </div>
          </div>
        );
      }
    }

    if(!this.state.currentTab ||
       !this.state.layers ||
       !this.state.layers[this.state.currentTab]) return null;

    let layerOptions = Object.keys(
      this.state.layers[this.state.currentTab],
    ).map(key => {
      return (
        <div key={key}>
          {this.renderTabChild(key)}
        </div>
      );
    });

    if(this.state.currentTab === 'overall-memorial_map'){
      if(this.state.selectedObject){
        const memorial = this.props.mapProgram.memorials.find(
          memorial => (memorial.caseId ? memorial.caseId.toString() : '') === this.state.selectedObject.toString() && memorial.title.toLowerCase() === this.state.memorialPopUpName.toLowerCase(),
        );

        if(memorial){
          return (
            <div {...this.getTabPanelContainerProps(tabId)}>
              <button aria-label="Close panel"
                      className="button-input__button tab-content-close-icon"
                      type="button" onClick={this.handleTabContentClose}>
                <img alt="" className="button-input__button-icon" src={iconClose}/>
              </button>
              <div className="map-program__tab-content"
                   key={this.state.currentTab}>
                <button type="button"
                        aria-label="Back to layer list"
                        className="memorial-close-button"
                        onClick={this.handleMemorialContent}>
                  <img alt="" className="button__icon" src={iconArrowRight}/>
                </button>
                {memorial.title && (<div className="map-program__memorial-title">{`${memorial.title}, ${memorial.age || ''}`}</div>)}
                {memorial.eventDate && (<div className="map-program__memorial-event">{`Died on ${moment(memorial.eventDate).format('MMMM D, YYYY')}`}</div>)}
                {memorial.address && (<div className="map-program__memorial-address">{memorial.address}</div>)}
                {memorial.media && (<div className="map-program__memorial-content">
                  <img alt={memorial.title}
                       className="map-program__memorial-media-imagery"
                       src={apiValues.imgPath(memorial.media.url)}/>
                </div>)}
                {memorial.description && (<MarkdownField className="map-program__memorial-description" markup={memorial.description}/>)}
                <a className='map-program__memorial-know' href={`mailto:visionzero@lacity.org?subject=Vision Zero Memorial Unidentified person (ID: ${this.state.selectedObject.toString()})&body=Hello, I am visiting the Vision Zero Memorial of someone I know and would like to create a memorial for them.`}>Did you know this person?</a>
                {/* <div className="map-program__memorial-read-more">
                  READ MORE
                  <MListNav
                    mListNav={mListNav}
                    className="m-listnav--page-content"
                  />
                </div> */}
                <ShareMemorial shareUrl={`https://${window.location.hostname}/overall-map/maps?sharememorial=${this.state.selectedObject.toString()}-${this.state.memorialPopUpName}`}
                               pageTitle={`${overallProgram.title} Memorial Map - ${memorial.title || ''}`}/>
              </div>
            </div>
          );
        }
      }

      return (
        <div {...this.getTabPanelContainerProps(tabId)}>
          <button
            aria-label="Close panel"
            className="button-input__button tab-content-close-icon"
            type="button" onClick={this.handleTabContentClose}
          >
            <img alt="" className="button-input__button-icon" src={iconClose}/>
          </button>
          <div className="map-program__tab-content" key={this.state.currentTab}>
            <div className="map-program__tab-content-title">
              Memorial Map
            </div>
            <div className="map-program__memorial-slider">
              <Range min={2010}
                     max={2019}
                     marks={{
                       2010: 2010,
                       2011: 2011,
                       2012: 2012,
                       2013: 2013,
                       2014: 2014,
                       2015: 2015,
                       2016: 2016,
                       2017: 2017,
                       2018: 2018,
                       2019: 2019,
                     }}
                     onChange={this.changeValue}
                     defaultValue={this.state.memorialDateFilter}
                     tipFormatter={value => `${value}%`}
                     trackStyle={[
                       {
                         backgroundColor: '#ff8563',
                       },
                     ]}
                     dotStyle={{
                       width: '2px',
                       backgroundColor: 'rgba(0, 0, 0, 0.54)',
                       border: 'none',
                     }}
                     activeDotStyle={{}}
                     handleStyle={[{
                       width: '27px',
                       height: '24px',
                       border: 'none',
                       borderRadius: '12px',
                       backgroundColor: 'rgba(0, 0, 0, 0.78)',
                       marginTop: '-10px',
                       marginLeft: '-16px',
                     },
                       {
                         width: '27px',
                         height: '24px',
                         border: 'none',
                         borderRadius: '12px',
                         backgroundColor: 'rgba(0, 0, 0, 0.78)',
                         marginTop: '-10px',
                         marginLeft: '-16px',
                       }]}/>
            </div>
            <div className="map-program__tab-content-description">
              Every dot on this map represents a person who passed away in a
              traffic crash and a person whose family and friends were deeply
              affected by their tragedy. The City of Los Angeles is committed to
              working with loved ones.
            </div>
            <div className="map-program__memorial-posts">LIVES LOST</div>
            {layerOptions}
          </div>
        </div>
      );
    }

    if(this.state.currentTab === 'overall-project_features'){
      layerOptions = features_types_name.filter(item => item && item.value && item.count).map(item => {
        const layer = this.state.layers[this.state.currentTab][item.value];
        return (
          <div key={item.value}>
            <div className="checkbox-item-container"
                 key={item.value}>
              <input checked={layer}
                     id={`input-${item.value}`}
                     onChange={() => this.onToggleFeatureLayer(item.value)}
                     type="checkbox"/>
              <label htmlFor={`input-${item.value}`}>{formatOverallProjectFeatureLabel(item)}</label>
            </div>
          </div>
        );
      });
    }

    layerOptions = layerOptions.filter(item => !!item);
    if(layerOptions.length === 0) return null;

    if(this.state.currentTab === 'overall-projects'){
      return (
        <div {...this.getTabPanelContainerProps(tabId)}>
          <button aria-label="Close panel"
                  className="button-input__button tab-content-close-icon"
                  type="button" onClick={this.handleTabContentClose}>
            <img alt="" className="button-input__button-icon" src={iconClose}/>
          </button>
          <div className="map-program__tab-content" key={this.state.currentTab}>
            <div className="map-program__tab-content-title">
              Our Projects
            </div>
            {layerOptions}
          </div>
        </div>
      );
    }

    return (
      <div {...this.getTabPanelContainerProps(tabId)}>
        <button aria-label="Close panel"
                className="button-input__button tab-content-close-icon"
                type="button" onClick={this.handleTabContentClose}>
          <img alt="" className="button-input__button-icon" src={iconClose}/>
        </button>
        <div className="map-program__tab-content" key={this.state.currentTab}>
          <div className="map-program__tab-content-title">
            {this.state.currentTab === 'overall-neighborhoods_zones' ? 'Neighborhoods, Networks, and Zones' : 'Project Features (Installed and Planned)'}
          </div>
          {layerOptions}
        </div>
      </div>
    );
  }
  renderTabChild(key){
    const layer = this.state.layers[this.state.currentTab][key];
    let layerTitle = layer_names[key] || OVERALL_LAYER_LABELS[key];
    if(key === 'coll_bik_fatal'){
      layerTitle = `Biking`;
    }
    else if(key === 'coll_car_fatal'){
      layerTitle = `Driving`;
    }
    else if(key === 'coll_ped_fatal'){
      layerTitle = `Walking`;
    }
    else if(key === 'memorial'){
      layerTitle = 'Memorials';
    }
    if(key === 'coll_bik_fatal' || key === 'coll_car_fatal' || key === 'coll_ped_fatal' || key === 'memorial'){
      return (
        <div className="checkbox-item-container"
             key={key}>
          <input checked={layer}
                 id={`input-${key}`}
                 onChange={() => this.onToggleLayer(key)}
                 type="checkbox"/>
          <label htmlFor={`input-${key}`}>
            <span className="memorial-map-layer-title">
              <span className="memorial-map-number-count"><b>{`${this.state.collisionDetail[key] || ''}`}</b></span>
              <span> {layerTitle}</span>
            </span>
          </label>
        </div>
      );
    }
    if(!layerTitle) return null;
    return (
      <div className="checkbox-item-container"
           key={key}>
        <input checked={layer}
               id={`input-${key}`}
               onChange={() => this.onToggleLayer(key)}
               type="checkbox"/>
        <label htmlFor={`input-${key}`}>{layerTitle}</label>
      </div>
    );
  }
  renderTabs(){
    if(!this.props.tabs ||
       !this.state.mapPluginReady) return null;

    let tabs = this.props.tabs.map(({id, name, type}) => this.renderTab(id, name, type?.icon));
    let openClass = this.state.filtersOpen ? 'map-program__tab-menu--filters-open' : '';
    let selectedClass = this.state.currentTab != '' ? 'map-program__tab-menu--is-open' : '';

    return (
      <div className={`map-program__tab-menu ${openClass} ${selectedClass}`}>
        <div className="map-program__tab-menu-tabs" role="tablist" aria-label="Map layers">{tabs}</div>
        {this.renderFilterControls()}
      </div>
    );
  }
  render(){
    // console.log(`MapProgram.render()`, this.props);
    if(!this.props.mapProgram ||
       !this.props.page ||
       !this.props.page.program ||
       !this.props.tabs) return null;

    return (
      <div className="map-program">
        {this.renderIntroSection()}
        {this.renderMapSection()}
      </div>
    );
  }
}


export default withRouter(connect(
  (state) => ({
    page: state.page,
    mapProgram: state.mapProgram,
  }),
  (dispatch) => ({
    actions: bindActionCreators(mapProgramActions, dispatch),
  }),
)(OverallMap));


OverallMap.propTypes = {
  actions: PropTypes.object,
  className: PropTypes.string,
  cmsId: PropTypes.string,
  history: PropTypes.object,
  location: PropTypes.object,
  mapProgram: PropTypes.object,
  mode: PropTypes.string.isRequired,
  page: PropTypes.object,
  tabs: PropTypes.array,
};
